import { Airline } from '../../../integrated-client/models'

export interface IAirlineEditorData {
  airlineData?: Airline
  validation?: any
}
export class AirlineEditorData implements IAirlineEditorData {

  airlineData?:  Airline
  validation?: any
}